import { User } from '../../../../types/user';

export const formatAddress = (user: User) => {
  return `${user.street} ${user.city}, ${user.state} ${user.zip}`;
};
